import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { RoutableProps } from "preact-router";
import { ScanPackQR } from "../../../components/ScanPackQR";
import "./styles.scss";
import { SerialNumberType } from "../../../data/types";
import { Snackbar, SnackbarShowCommand } from "../../../components/Snackbar";
import { useCommand, useForceUpdate } from "../../../hooks";
import { addProductToDatabase, getSerialNumberInfo, Product } from "../../../api/product-api";

const serialRegexAny = /^([0-9A-Za-z-_:/]{4,32})$/m;

export function StellaBIOExternal(props: RoutableProps) {
    const [tabletType, setTabletType] = useState("");
    const [serialNumber, setSerialNumber] = useState("");
    const [isSerialNumberValid, setIsSerialNumberValid] = useState(false);
    const [serialNumbers, setSerialNumbers] = useState([] as { type: string, serialNumber: string, valid: boolean, registered?: boolean }[]);
    const [typeInfo, setTypeInfo] = useState(null as { type: SerialNumberType, data: Product } | null);
    const forceUpdate = useForceUpdate();
    const showSnackbar = useCommand<SnackbarShowCommand>();

    useEffect(() => {
        setIsSerialNumberValid(false);

        if (!serialNumber) {
            setTypeInfo(null);
            return;
        }

        if (!serialNumber.match(serialRegexAny)) {
            setTypeInfo(null);
            showSnackbar.run("Podany numer seryjny jest w złym formacie", "error", "error", 3000);
            return;
        }

        setIsSerialNumberValid(true);
    }, [serialNumber]);

    useEffect(() => {
        getSerialNumberInfo(serialNumbers.map(v => v.serialNumber)).then((products) => {
            for (let i = 0; i < serialNumbers.length; i++) {
                serialNumbers[i].valid = true;
                delete serialNumbers[i].registered;
            }

            for (let i = 0; i < products.length; i++) {
                const product = products[i];
                const serialNumberData = serialNumbers.find(v => v.serialNumber === product.serialNumber);

                if (serialNumberData) {
                    serialNumberData.valid = false;
                }
            }

            forceUpdate();
        });
    }, [serialNumbers]);

    return <div class="luna-emg-tablet-page">
        <Snackbar doShow={showSnackbar}/>
        <div class="paper serial-input">
            <ScanPackQR onRead={(data) => {
                const text = JSON.parse(data) as string;
                let match = serialRegexAny.exec(text);

                if (!match || match.length < 2) {
                    return;
                }

                setSerialNumber(match[1].trim());
            }}/>
            <div>
                <label>
                    <span style="margin-right: 10px;">Wybierz rodzaj urządzenia</span>
                    <select value={tabletType} onChange={(e) => setTabletType(e.currentTarget.value)}>
                        <option value="ACC-Laptop-Asus-Expert-Book-B1500C">Laptop Asus ExpertBook B1500C</option>
                        <option value="ACC-WiFi-TPLink-AC600-T2U-Nano">WiFi USB TP-Link AC600 T2U Nano</option>
                        <option value="ACC-WiFi-TPLink-TL-WN725N">WiFi USB TP-Link TL-WN725N</option>
                        <option value="ACC-Laptop-Dell-Latitude-3520">Laptop DELL Latitude 3520</option>
                        <option value="ACC-Laptop-Acer-Aspire-3">Laptop Acer Aspire 3</option>
                        <option value="ACC-Laptop-Dynabook-Satellite-Pro-C50">Laptop Toshiba Dynabook Satellite Pro C50</option>
                        <option value="ACC-Tablet-Lenovo-Tab-P11-5G">Tablet Lenovo Tab P11 5G</option>
                    </select>
                </label>
            </div>
            <div style="margin-top: 10px;">
                <label>
                    <span style="margin-right: 10px;">Podaj lub zeskanuj numer seryjny urządzenia</span>
                    <input value={serialNumber} onChange={e => {
                        setSerialNumber(e.currentTarget.value.trim());
                        e.currentTarget.setCustomValidity(!e.currentTarget.value.match(serialRegexAny) ? "Nieprawidłowy numer seryjny" : "");
                    }} />
                </label>
            </div>
            <div style="margin-top: 10px;">
                <button class={isSerialNumberValid && tabletType ? "" : "disabled"} onClick={() => {
                    if (!tabletType || serialNumbers.find(v => serialNumber === v.serialNumber)) {
                        return;
                    }

                    setSerialNumbers([
                        ...serialNumbers,
                        {
                            type: tabletType,
                            serialNumber,
                            valid: false
                        }
                    ]);
                }}>Dodaj Urządzenie</button>
            </div>
            <div class="paper-2 serial-list">
                <h2 style="padding-bottom: 10px;">Urządzenia do rejestracji</h2>
                <table style="width: 100%; text-align: left;">
                    <thead>
                        <th>Typ</th>
                        <th>Numer seryjny</th>
                        <th>Walidacja</th>
                        <th>Usuń</th>
                    </thead>
                    <tbody>
                        {serialNumbers.map((v, i) => <tr class={(v.registered === true ? "register-success" : v.registered === false ? "register-fail" : "")}>
                            <td style="white-space: nowrap">{v.type}</td>
                            <td style="width: 100%">{v.serialNumber}</td>
                            <td class="validation">{!v.valid ? <button class="icon r26 error tooltip-accent tooltip-bottom" data-tooltip="Urządzenie o podanym numerze seryjnym istnieje już w bazie danych">priority_high</button>
                                : <button class="icon r26 success tooltip-accent tooltip-bottom" data-tooltip="Numer seryjny jest poprawny">check</button>}
                            </td>
                            <td class="remove">
                                <button type="button" class="flat icon error tooltip-top" data-tooltip="Usuwa pozycje z listy" onClick={() => {
                                    serialNumbers.splice(i, 1);
                                    setSerialNumbers([...serialNumbers]);
                                }}>close</button>
                            </td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
            <div style="margin-top: 10px">
                <button type="button" class={serialNumbers.length > 0 && serialNumbers.every(v => v.valid) ? "" : "disabled"} onClick={async () => {
                    const promises = [];

                    for(let i = 0; i < serialNumbers.length; i++) {
                        const serialNumberData = serialNumbers[i];

                        promises.push(addProductToDatabase(serialNumberData.type, serialNumberData.serialNumber, serialNumberData.type).then(() => {
                            serialNumberData.registered = true;
                            forceUpdate();
                        }).catch((ex) => {
                            serialNumberData.registered = false;
                            forceUpdate();
                            throw ex;
                        }));
                    }

                    try {
                        await Promise.all(promises);
                        showSnackbar.run("Wszystkie urządzenia zostały zarejestrowane pomyślnie", "success", "check");
                    }
                    catch(ex) {
                        console.error(ex);
                        showSnackbar.run("Nie udało się zarejestrować niektórych urządzeń", "error", "check");
                    }
                }}>Zarejestruj</button>
            </div>
        </div>
    </div>;
}
